import React from 'react';
import './Properties_listing.css'
import Header from '../Componenents/layout/header';
import Hero_2 from '../Assets/Hero_2.jpg'
import Search_icon from '../Assets/Search.svg'
import Fillter_icon from '../Assets/fillter icon.svg'
import Filter_input from '../Componenents/comman/Filter_input'
import Properties_Card from '../Componenents/comman/Properties_card'
import House_1 from '../Assets/houseimg 1.png'
import House_2 from '../Assets/houseimg 2.jpg'
import House_3 from '../Assets/houseimg 3.jpg'
import House_4 from '../Assets/houseimg 4.jpg'
import House_5 from '../Assets/houseimg 5.jpg'
import House_6 from '../Assets/houseimg 6.jpg'
import Footer from '../components/Footer';

const Properties_listing = () => {
  return (
    <>
      <Header />
      <main>
        <div className="hero_2">
          <img src={Hero_2} alt="" className="hero_img2" />
          <div className='hero2_div1'>
            <h1 className='hero_h1'>Discover Premium Properties</h1>
            <h4 className='hero2_h4'>Browse our exclusive collection of luxury real estate across Egypt</h4>
            <div className="hero2_search">
              <img className='search_icon' src={Search_icon} alt="" />
              <input className="hero2_input" type="text" placeholder="Search by city, area, or property name..." />
            </div>
          </div>
        </div>

        <div className='properties_div1'>
          <div className='properties_fillters'>
            <div className="properties_fillters_div1">
              <div className="properties_fillters_left">
                <img className="properties_filler_icon" src={Fillter_icon} alt="Filter" />
                <h4 className="properties_filler_text1">Filters</h4>
              </div>
              <h5 className="properties_filler_text2">Clear All</h5>
            </div>
            <Filter_input text="Location" />
            <Filter_input text="Price Range" />
            <Filter_input text="Bedrooms" />
            <Filter_input text="Property Type" />
            <div className="properties_fillters_div1">
              <button className="filter_btn">Apply Filter</button>
            </div>
          </div>

          <div className='properties_right'>
            <div className='properties_cards_grid'>
              <Properties_Card img={House_1} price="EGP 15,500,000" name="Contemporary Villa" location="New Cairo, Cairo" rooms="5" bathrooms="2" area="450 m²" />
              <Properties_Card img={House_2} price="EGP 22,000,000" name="Luxury Modern Estate" location="Sheikh Zayed, Giza" rooms="5" bathrooms="3" area="600 m²" />
              <Properties_Card img={House_3} price="EGP 12,800,000" name="Penthouse with City" location="New Cairo, Cairo" rooms="5" bathrooms="3" area="350 m²" />
              <Properties_Card img={House_4} price="EGP 28,500,000" name="Beachfront Villa" location="North Coast" rooms="6" bathrooms="2" area="520 m²" />
              <Properties_Card img={House_5} price="EGP 8,500,000" name="Modern Luxury" location="New Cairo, Cairo" rooms="3" bathrooms="1" area="220 m²" />
              <Properties_Card img={House_6} price="EGP 35,000,000" name="Premium Estate" location="6th of October, Giza" rooms="7" bathrooms="3" area="800 m²" />
              <Properties_Card img={House_1} price="EGP 15,500,000" name="Contemporary Villa" location="New Cairo, Cairo" rooms="5" bathrooms="2" area="450 m²" />
              <Properties_Card img={House_2} price="EGP 22,000,000" name="Luxury Modern Estate" location="Sheikh Zayed, Giza" rooms="5" bathrooms="3" area="600 m²" />
              <Properties_Card img={House_3} price="EGP 12,800,000" name="Penthouse with City" location="New Cairo, Cairo" rooms="5" bathrooms="3" area="350 m²" />
              <Properties_Card img={House_4} price="EGP 28,500,000" name="Beachfront Villa" location="North Coast" rooms="6" bathrooms="2" area="520 m²" />
              <Properties_Card img={House_5} price="EGP 8,500,000" name="Modern Luxury" location="New Cairo, Cairo" rooms="3" bathrooms="1" area="220 m²" />
              <Properties_Card img={House_6} price="EGP 35,000,000" name="Premium Estate" location="6th of October, Giza" rooms="7" bathrooms="3" area="800 m²" />
            </div>

            <div className="pagination">
              <button className="page_btn">Previous</button>
              <div className="page_numbers">
                <span className="page active">1</span>
                <span className="page">2</span>
                <span className="page">3</span>
                <span className="page">4</span>
              </div>
              <button className="page_btn">Next</button>
            </div>
          </div>
        </div>
      </main>
      <Footer/>
    </>
  );
}

export default Properties_listing;